export default __webpack_public_path__ + "static/media/resultados.d1252ffc.jpg";